import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
var _div, _Devtool;
/* eslint-disable no-restricted-properties */
/**
 * this file contains the logic to check if we should load or not the entire devtool app.
 */
import * as React from 'react';
import { createRoot } from 'react-dom/client';
import { ErrorBoundary } from 'react-error-boundary';
import { Loadable } from "./components";
import { jsx as _jsx } from "react/jsx-runtime";
var productionHost = 'www.crehana.com';
var isDevelopment = function isDevelopment() {
  return process.env.NODE_ENV !== 'production' || typeof window !== 'undefined' && window.location.host !== productionHost;
};
var Devtool = function Devtool() {
  var _React$useState = React.useState(true),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    loading = _React$useState2[0],
    setLoading = _React$useState2[1];
  var _React$useState3 = React.useState(false),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    loadDevtool = _React$useState4[0],
    setLoadDevtool = _React$useState4[1];
  React.useEffect(function () {
    var enabledByQueryParam = window.location.search.includes('devtools=true');
    var enabledByLocalStorage = window.localStorage.getItem('devtools') === 'true';
    if (isDevelopment() && (enabledByQueryParam || enabledByLocalStorage)) {
      setLoadDevtool(true);
    }
    setLoading(false);
  }, []);
  if (loading || !loadDevtool) {
    return null;
  }
  return /*#__PURE__*/_jsx(Loadable, {
    module: function module() {
      return import(/* webpackChunkName: "devtools-main-chunk" */"./App");
    }
  });
};
var DEVTOOLS_ROOT_ID = '__crehana-devtools-root';
export var install = function install() {
  // dont try to load the app in ssr
  if (typeof window === 'undefined') {
    return undefined;
  }
  if (document.getElementById(DEVTOOLS_ROOT_ID)) {
    return undefined;
  }
  try {
    var devToolsRoot = document.createElement('div');
    devToolsRoot.id = DEVTOOLS_ROOT_ID;
    document.body.appendChild(devToolsRoot);
    var root = createRoot(devToolsRoot);
    root.render(/*#__PURE__*/_jsx(ErrorBoundary, {
      FallbackComponent: function FallbackComponent() {
        return _div || (_div = /*#__PURE__*/_jsx("div", {}));
      },
      children: _Devtool || (_Devtool = /*#__PURE__*/_jsx(Devtool, {}))
    }));
  } catch (err) {
    console.error('Error to load the devtools :(', err);
  }
};